import { LoadState } from "../../constants/enums";

export interface IButtonRoleVisibility {
  button_role_visibility_id?: string;
  button_name: string;
  module_name: string;
  sub_module: string;
  roles: string[];
  status: string;
  insert_ts?: string;
  button_role_code: string;
}

export interface IButtonRoleVisibilityState {
  data: {
    list: IButtonRoleVisibility[];
    totalRecords: number;
    loading: LoadState;
  };
  runtimeRefData: {
    [code: string]: {
      loading: LoadState;
      record: IButtonRoleVisibility | null;
    };
  };
}

export const initialButtonRoleVisibilityState: IButtonRoleVisibilityState = {
  data: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
  },
  runtimeRefData: {},
};
